import styled from 'styled-components';
import { IProviderItemView } from '../../store/providers/providerTypes';

const citationGreen = '#44BA8E';

const CitationContainer = styled.div`
  align-self: flex-end;
  margin: 0.5rem;
  margin-inline-end: 0;
  display: flex;
  align-items: flex-end;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: calc(100% - 8rem);
`;

const CitationItem = styled('a')`
  color: ${citationGreen};
  border: 1px solid ${citationGreen};
  border-radius: 10rem;
  padding: 0.1rem 0.75rem 0;
  font-size: 0.75rem;
  transition: all 0.25s ease-in;
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  gap: 0.25rem;
  text-align: end;

  &:hover {
    background: ${citationGreen};
    color: var(--exact-white);
    transform: scale(1.05);
    box-shadow: 0 0.25rem 0.75rem #cccccc;
  }

  @media only screen and (max-width: 800px) {
    font-size: 0.7rem;
    & * {
      font-size: 0.75rem;
    }
  }
`;

interface IProps {
  annotations: { [key: string]: IProviderItemView };
}

const FileCitation: React.FC<IProps> = ({ annotations }) => {
  return (
    <CitationContainer>
      {annotations &&
        Object.keys(annotations).map((annotationKey) => {
          const url = `${window.location.origin}${window.location.pathname}/f/${annotations[annotationKey].dadId}?modal=${annotations[annotationKey].id}`;
          return (
            <CitationItem key={annotationKey} href={url} target="_blank">
              <>
                {/*<FaLink />*/}
                {annotations[annotationKey].name}
              </>
            </CitationItem>
          );
        })}
    </CitationContainer>
  );
};

export default FileCitation;
